module.exports = __webpack_public_path__ + "static/img/homeBotBg.a3e57a85.png";